<template>
  <div class="header header--company" v-if="!isMobile">
		<SidebarTrigger class="mb-2" />
    <header-company-block></header-company-block>
    <require-access data="dashboard-company_balance" action="read">
      <div class="header__balance-wrapper">
        <header-company-balance
          class="header__balance-block"
          @openPopup="handleOpenPopup"
          :is-open-popup="isOpenPopup"
        ></header-company-balance>
        <div
          class="wallet_popup"
          v-if="isOpenPopup"
          v-click-outside="hideCompaniesSwitcher"
        >
          <div v-if="walletItems.length" class="wallet_popup-title">
            <div class="icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 7.5C11.982 7.5 15 6.4695 15 4.5C15 2.5305 11.982 1.5 9 1.5C6.018 1.5 3 2.5305 3 4.5C3 6.4695 6.018 7.5 9 7.5Z"
                  fill="white"
                />
                <path
                  d="M3 7.5C3 9.4695 6.018 10.5 9 10.5C11.982 10.5 15 9.4695 15 7.5V6C15 7.9695 11.982 9 9 9C6.018 9 3 7.9695 3 6V7.5Z"
                  fill="white"
                />
                <path
                  d="M3 10.5C3 12.4695 6.018 13.5 9 13.5C11.982 13.5 15 12.4695 15 10.5V9C15 10.9695 11.982 12 9 12C6.018 12 3 10.9695 3 9V10.5Z"
                  fill="white"
                />
                <path
                  d="M3 13.5C3 15.4695 6.018 16.5 9 16.5C11.982 16.5 15 15.4695 15 13.5V12C15 13.9695 11.982 15 9 15C6.018 15 3 13.9695 3 12V13.5Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="title">{{ $t('company.available-balance.title') }}</div>
          </div>
          <div
            class="wallet_popup-block"
            v-if="walletItems.length"
            :class="{ 'wallet_popup-big-block': walletItems.length >= 5 }"
          >
            <div
              class="item"
              v-for="wallet in walletItems"
              :key="wallet.id"
              @click="goToCompany(wallet)"
              :class="{ active: wallet.id === activeCompanyId }"
            >
              <div class="wallet_icon">
                <svg
                  width="11"
                  height="10"
                  viewBox="0 0 11 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1.25C0 0.5625 0.55 0 1.22222 0H9.16667C9.32874 0 9.48418 0.065848 9.59879 0.183058C9.71339 0.300268 9.77778 0.45924 9.77778 0.625V1.25H1.22222V1.875H10.3889C10.551 1.875 10.7064 1.94085 10.821 2.05806C10.9356 2.17527 11 2.33424 11 2.5V8.75C11 9.08152 10.8712 9.39946 10.642 9.63388C10.4128 9.8683 10.1019 10 9.77778 10H1.22222C0.898069 10 0.587192 9.8683 0.357981 9.63388C0.128769 9.39946 0 9.08152 0 8.75V1.25ZM8.86111 6.875C9.10423 6.875 9.33738 6.77623 9.50929 6.60041C9.6812 6.4246 9.77778 6.18614 9.77778 5.9375C9.77778 5.68886 9.6812 5.4504 9.50929 5.27459C9.33738 5.09877 9.10423 5 8.86111 5C8.618 5 8.38484 5.09877 8.21293 5.27459C8.04102 5.4504 7.94444 5.68886 7.94444 5.9375C7.94444 6.18614 8.04102 6.4246 8.21293 6.60041C8.38484 6.77623 8.618 6.875 8.86111 6.875Z"
                    :fill="wallet.fill"
                  />
                </svg>
              </div>
              <div class="wallet_data">
                <div class="data_balance">
                  <span class="balance">{{
                    formatBalance(wallet.balance)
                  }}</span
                  ><span class="currency">{{
                    getCurrencyValue(wallet.wallet)
                  }}</span>
                </div>
                <div class="data_iban">
                  <span>{{ wallet.wallet }}</span>
                  <svg
                    width="5"
                    height="8"
                    viewBox="0 0 5 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.52433 3.64913L1.0016 0.126462C0.920118 0.0449215 0.811354 0 0.695382 0C0.57941 0 0.470646 0.0449215 0.38917 0.126462L0.129745 0.385823C-0.0390649 0.554826 -0.0390649 0.829503 0.129745 0.998248L3.08787 3.95637L0.126462 6.91778C0.0449859 6.99932 0 7.10802 0 7.22393C0 7.33997 0.0449859 7.44867 0.126462 7.53027L0.385887 7.78957C0.467428 7.87111 0.576128 7.91603 0.6921 7.91603C0.808072 7.91603 0.916836 7.87111 0.998313 7.78957L4.52433 4.26368C4.606 4.18188 4.65086 4.07267 4.6506 3.95657C4.65086 3.84002 4.606 3.73087 4.52433 3.64913Z"
                      fill="#E0E6F2"
                    />
                  </svg>
                </div>
                <div class="data_name">
                  <span>{{ wallet.company_name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="wallet_popup-block" v-else>
            <span>{{ $t('company.empty-balance.title') }}</span>
          </div>
        </div>
      </div>
    </require-access>
    <header-export-block class="header__export-block"></header-export-block>
    <header-support-block class="header__support-block"></header-support-block>
    <header-user-block></header-user-block>
  </div>
  <div class="header-mobile header-mobile--home" v-else>
    <div class="header-mobile__top">
      <logo class="header-mobile__logo"></logo>
      <router-link to="/cabinet/profile" class="header-mobile__profile">
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="29" height="29" rx="7" fill="#64748B" />
          <path
            d="M14.5784 22.5731C10.0668 22.5731 6.39648 18.8802 6.39648 14.3407C6.39648 9.80083 10.0668 6.10742 14.5784 6.10742C19.0913 6.10742 22.7627 9.80055 22.7627 14.3407C22.7627 18.8802 19.0913 22.5731 14.5784 22.5731ZM14.5784 7.48819C10.8281 7.48819 7.77698 10.5621 7.77698 14.3407C7.77698 18.1187 10.8278 21.1923 14.5784 21.1923C18.33 21.1923 21.3822 18.1187 21.3822 14.3407C21.3822 10.5624 18.33 7.48819 14.5784 7.48819Z"
            fill="white"
          />
          <path
            d="M24.2584 24.8034C24.6397 24.8034 24.9487 24.4943 24.9487 24.113V24.1715C24.9487 21.6778 23.5677 19.7883 20.9543 18.707C20.6021 18.5611 20.1986 18.7287 20.0527 19.0806C19.9071 19.4328 20.0744 19.8366 20.4266 19.9822C22.5405 20.8572 23.5683 22.2273 23.5683 24.1713V24.113C23.568 24.4943 23.877 24.8034 24.2584 24.8034Z"
            fill="white"
          />
          <path
            d="M24.2588 24.8034C24.6402 24.8034 24.9492 24.4943 24.9492 24.113V24.1715C24.9492 21.6778 23.5682 19.7883 20.9547 18.707C20.6025 18.5611 20.1989 18.7287 20.0531 19.0806C19.9075 19.4328 20.0748 19.8366 20.427 19.9822C22.541 20.8572 23.5687 22.2273 23.5687 24.1713V24.113C23.5684 24.4943 23.8775 24.8034 24.2588 24.8034Z"
            fill="white"
          />
          <path
            d="M4.69038 24.8034C4.30907 24.8034 4 24.4943 4 24.113V24.1715C4 21.6778 5.38104 19.7883 7.99451 18.707C8.3467 18.5611 8.75028 18.7287 8.89615 19.0806C9.04176 19.4328 8.87445 19.8366 8.52225 19.9822C6.40824 20.8572 5.38049 22.2273 5.38049 24.1713V24.113C5.38077 24.4943 5.0717 24.8034 4.69038 24.8034Z"
            fill="white"
          />
          <path
            d="M12.458 14.1776H11.5256C11.144 14.1776 10.835 13.8686 10.835 13.487C10.835 13.1059 11.144 12.7969 11.5256 12.7969H12.458C12.8394 12.7969 13.1484 13.1059 13.1484 13.487C13.1484 13.8686 12.8394 14.1776 12.458 14.1776Z"
            fill="white"
          />
          <path
            d="M17.7515 14.1776H16.8188C16.4375 14.1776 16.1284 13.8686 16.1284 13.487C16.1284 13.1059 16.4375 12.7969 16.8188 12.7969H17.7515C18.1328 12.7969 18.4419 13.1059 18.4419 13.487C18.4419 13.8686 18.1328 14.1776 17.7515 14.1776Z"
            fill="white"
          />
          <path
            d="M16.2858 16.1191C15.6905 17.3096 14.5001 17.3096 14.5001 17.3096C14.5001 17.3096 13.3096 17.3096 12.7144 16.1191"
            stroke="white"
            stroke-linecap="round"
          />
        </svg>
      </router-link>
      <div class="header-mobile__menu-button" @click="$emit('toggleSidebar')">
        <svg
          width="27"
          height="18"
          viewBox="0 0 27 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="27" height="2" rx="1" fill="#465A8B" />
          <rect width="27" height="2" rx="1" fill="#465A8B" />
          <rect y="16" width="27" height="2" rx="1" fill="#465A8B" />
          <rect y="8" width="18" height="2" rx="1" fill="#465A8B" />
          <rect y="8" width="18" height="2" rx="1" fill="#465A8B" />
        </svg>
      </div>
    </div>
    <header-company-block class="header-mobile__company"></header-company-block>
  </div>
</template>

<script>
import HeaderSupportBlock from '@vue-app/components/header/parts/HeaderSupportBlock.vue'
import HeaderUserBlock from '@vue-app/components/header/parts/HeaderUserBlock.vue'
import HeaderCompanyBlock from '@vue-app/components/header/parts/HeaderCompanyBlock.vue'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import Logo from '@vue-app/components/base/Logo.vue'
import HeaderCompanyBalance from '@vue-app/components/header/parts/HeaderCompanyBalance.vue'
import HeaderExportBlock from '@vue-app/components/header/parts/HeaderExportBlock.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import { SidebarTrigger } from '@ui/sidebar'

export default {
  props: {
    wallets: {
      type: [Array, Object],
      default: () => [] || {},
    },
  },
  name: 'CompanyHeader',
  data() {
    return {
      isOpenPopup: false,
      activeCompanyId: null,
    }
  },
  components: {
    RequireAccess,
    HeaderExportBlock,
    HeaderCompanyBalance,
    HeaderCompanyBlock,
    HeaderUserBlock,
    HeaderSupportBlock,
    Logo,
		SidebarTrigger
  },
  mixins: [responsiveMixin],
  computed: {
    // walletItems() {
    //   return this.wallets.map(wallet => ({
    //     id: Math.floor(Math.random() * 1000),
    //     ...wallet,
    //     fill: this.getRandomFillColor()
    //   }))
    // }

    walletItems() {
      return this.wallets.map((wallet) => ({
        id: crypto.getRandomValues(new Uint32Array(1))[0],
        ...wallet,
        fill: this.getRandomFillColor(),
      }))
    },
  },
  methods: {
    getCurrencyValue(walletString) {
      const currencyMatch = walletString.match(/^[A-Z]{3}/)
      return currencyMatch ? currencyMatch[0] : ''
    },

    // formatBalance(balance) {
    //   const b = balance / 100;
    //   return b.toFixed(2).replace(/(?<=\d)(?=(\d{3})+(?!\d))/g, ' ');
    // },

    formatBalance(balance) {
      return (balance / 100).toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    handleOpenPopup(value) {
      this.isOpenPopup = value
    },

    goToCompany(wallet) {
      this.$router.push({
        name: 'company-dashboard',
        params: { id: wallet.company_id },
      })
      this.activeCompanyId = wallet.id
      this.isOpenPopup = false
    },

    hideCompaniesSwitcher() {
      if (!this.isMobile) {
        this.isOpenPopup = false
      }
    },

    // getRandomFillColor() {
    //   const predefinedColors = ['#ff2d00', '#33FF57', '#3366FF', '#FFFF33', '#FF33FF', '#33FFFF'];
    //   return predefinedColors[Math.floor(Math.random() * predefinedColors.length)];
    // }

    getRandomFillColor() {
      const predefinedColors = [
        '#ff2d00',
        '#33FF57',
        '#3366FF',
        '#FFFF33',
        '#FF33FF',
        '#33FFFF',
      ]
      const array = new Uint32Array(1)
      ;(window.crypto || window.msCrypto).getRandomValues(array)
      const index = array[0] % predefinedColors.length
      return predefinedColors[index]
    },
  },
  emits: ['toggleSidebar'],
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
	width: 3px;
}

::-webkit-scrollbar-thumb {
	background: #fff;
	border-radius: 12px;
}

::-webkit-scrollbar-track {
	background-color: transparent;
}

.header {
	&__balance-wrapper {
		position: relative;
		display: flex;
		flex-direction: column;
	}

	&--company {
		display: flex;
		align-items: center;
		height: 43px;
	}

	&--company & {
		&__support-block {
			margin-left: auto;
			margin-right: 60px;
		}
	}

	&__balance-block {
		position: relative;
		margin-left: 40px;
		flex-grow: 0;
		flex-shrink: 0;
	}

	&__export-block {
		margin-right: 60px;
		margin-left: 60px;
	}
}

.wallet_popup {
	position: absolute;
	top: 40px;
	width: 300px;
	max-height: 400px;
	background-color: #fff;
	border-radius: 8px;
	z-index: 11;

	.wallet_popup-title {
		padding: 20px;
		display: flex;
		align-items: center;
		gap: 20px;
		span {
			font-size: 12px;
			font-weight: 700;
			line-height: 12px;
			color: #666D79;
		}

		.icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 44px;
			height: 44px;
			border-radius: 15px;
			background-color: #64748B;
		}

		.title {
			font-size: 16px;
			font-weight: 500;
			color: #B9C4D8;
		}
	}

	.wallet_popup-block {
		span {
			font-size: 12px;
			font-weight: 700;
			line-height: 12px;
			color: #666D79;
		}
		.item {
			cursor: pointer;
			display: flex;
			gap: 10px;
			border-top: 1px solid #909cb01c;
			padding: 10px 20px;
			.wallet_data {
				display: flex;
				flex-direction: column;
				gap: 6px;
				width: 100%;
				.data_name {
					display: flex;
					span {
						font-size: 10px;
						font-weight: 400;
						line-height: 15px;
						color: #B9C4D8;
					}
				}

				.data_iban {
					display: flex;
					justify-content: space-between;
					align-items: center;
					gap: 15px;
					span {
						font-weight: 600;
						font-size: 10px;
						line-height: 11px;
						color: #585F6D;
					}
				}

				.data_balance {
					display: flex;
					align-items: center;
					gap: 5px;
					span {
						font-size: 14px;
						font-weight: 600;
						line-height: 12px;
						color: #64748B
					}
				}
			}

			.wallet_icon {
				display: flex;
			}

			&.active {
				background-color: #909cb01c;
			}

			&:hover {
				background-color: #909cb01c;
			}
		}

		&.wallet_popup-big-block {
			max-height: 400px;
			overflow-y: auto;
			background-color: #fff;
		}
	}
}

@media screen and (max-width: 992px) {
	.header-mobile {
		&__top {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 36px 0;
		}

		&__profile {
			margin-left: auto;
			margin-right: 27px;
			cursor: pointer;

			&:hover {
				opacity: .8;
			}
		}

		&__company {
			margin-top: 10px;
		}

		&__menu-button {
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			&:hover {
				opacity: .8;
			}
		}
	}
}
</style>
